var HubSubscription = /** @class */ (function () {
    function HubSubscription(receiver, onReceive) {
        this.receiver = receiver;
        this.onReceive = onReceive;
    }
    HubSubscription.prototype.unSubscribe = function () {
        this.receiver.unSubscribe(this);
    };
    HubSubscription.prototype.dispose = function () {
        this.unSubscribe();
    };
    return HubSubscription;
}());
export default HubSubscription;
